module.exports = __webpack_public_path__ + "media/images/features/3/album/main-4-745d572c47d01d9063a54e387aa5c622.jpg";